import moment from "moment";
import React, { memo } from "react";
import { OwnershipTypes } from "../../../Form2553Creation/steps/Shareholders/types";

type Props = {
    document: Record<string, any>,
    handleDownload: (doc: Record<string, any>) => void,
    shareholder: Record<string, any>;
}
function TabContent(props: Props) {
    const { shareholder, handleDownload } = props;

    const downloadDocument = (doc: Record<string, any>) => {
        handleDownload(shareholder);
    }

    return (
        <>
            <div className="w-full px-3 flex pb-4">
                <div className="flex-1">
                    <div className="font-normal text-base text-600 line-height-3">
                        Email:
                    </div>
                    <div className="font-base text-lg text-black-alpha-90 line-height-3">
                        {shareholder.email}
                    </div>
                </div>
                <div className="flex-1">
                    <div className="font-normal text-base text-600 line-height-3">
                        Document:
                    </div>
                    <div className="font-base text-lg text-black-alpha-90 line-height-3 cursor-pointer" onClick={downloadDocument}>
                        <i className="pi pi-file-o text-primary-500 mr-2" />
                        {shareholder.fileName}
                        <i className="pi pi-download ml-2" />
                    </div>
                </div>
            </div>
            {
                shareholder.userType === "SHARE_HOLDER" ? (
                    <>
                        <div className="w-full px-3 flex mb-4 pb-4 pt-4 border-bottom-1 border-top-1 border-gray-300">
                            <div className="flex-1">
                                <div className="font-normal text-base text-600 line-height-3">
                                    {shareholder.ownershipType === OwnershipTypes.INDIVIDUAL ? "SSN/ITIN:" : "EIN:"}
                                </div>
                                <div className="font-base text-lg text-black-alpha-90 line-height-3">
                                    {shareholder.ein}
                                </div>
                            </div>
                            <div className="flex-1">
                                <div className="font-normal text-base text-600 line-height-3">
                                    {
                                        shareholder.numberOfShares ? " Number of shares:" : "Ownership percentage:"
                                    }
                                </div>
                                <div className="font-base text-lg text-black-alpha-90 line-height-3">
                                    {
                                        shareholder.numberOfShares ?
                                            Number(shareholder.numberOfShares).toLocaleString("en-US") + " shares" : shareholder.ownershipPercentage + "%"
                                    }
                                </div>
                            </div>
                            <div className="flex-1">
                                <div className="font-normal text-base text-600 line-height-3">
                                    Date acquired:
                                </div>
                                <div className="font-base text-lg text-black-alpha-90 line-height-3">
                                    {moment(shareholder.dateAcquired).format('MMMM DD, YYYY')}
                                </div>
                            </div>
                            <div className="flex-1">
                                <div className="font-normal text-base text-600 line-height-3">
                                    Tax year ends:
                                </div>
                                <div className="font-base text-lg text-black-alpha-90 line-height-3">
                                    {
                                        shareholder.taxYearEndMonthAndDay ?
                                            moment(shareholder.taxYearEndMonthAndDay).format('MMMM DD') : null
                                    }
                                </div>
                            </div>
                        </div>

                        <div className="w-full px-3 flex mb-4 pb-4">
                            <div className="w-full">
                                <div className="font-normal text-base text-600 line-height-3">
                                    Address:
                                </div>
                                <div className="font-base text-lg text-black-alpha-90 line-height-3">
                                    {
                                        [
                                            shareholder.address.line1,
                                            shareholder.address.city,
                                            shareholder.address.state.concat(` ${shareholder.address.zipCode}`),
                                            shareholder.address.country
                                        ].join(", ")
                                    }

                                </div>
                            </div>
                        </div>
                    </>
                ) : null
            }
        </>
    )
}

export default memo(TabContent)